import React, { Fragment } from "react";
import { THindcastOption } from "../../../api/endpoints/SubsetOption";
import { formatHindcastDay } from "../../../utils/Format";
import Checkbox from "../../Inputs/Checkbox/Checkbox";
import CheckboxWrap from "../../Ui/CheckboxWrap";
import SelectAllControl from "../SelectAllControl";

interface Props {
  values: Array<string>;
  spec: THindcastOption;
  onChange: (values: THindcastOption['value']['hindcast']) => void;
}

const HindcastSelector = (props: Props) => {
  const { spec, values, onChange } = props;

  const options = spec.value.hindcast;

  const onDayChange = (value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  };

  return (
    <Fragment>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <CheckboxWrap>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={formatHindcastDay(Number(option))}
              value={option}
              checked={values.includes(option)}
              name="hindcast-days"
              onChange={(checked) => onDayChange(option, checked)}
            />)
        }
      </CheckboxWrap>
    </Fragment>
  );
}

export default HindcastSelector;
